<template>
  <WebccLoaderOverlay v-if="requestPending" class="!bg-bgr" />
  <div v-else class="flex flex-col max-w-l grow">
    <ResetPasswordForm @success="returnAfterSuccess" @refresh="refresh" />
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  (e: 'goTo', value: AuthFlowType): void
  (e: 'isReady'): void
}>()

const auth = useAuthStore()
const authFlow = useAuthFlow()

const requestPending = ref(false)

onMounted(() => {
  emit('isReady')
})

checkAuthenticationStatus()

function checkAuthenticationStatus() {
  requestPending.value = true
  const isAuthntctd = auth.isAuthorized

  if (isAuthntctd) {
    const sessn = auth.session
    if (sessn) {
      const authmethods = sessn.authentication_methods
      if (authmethods) {
        const [authmethod] = authmethods
        const authmethodType = authmethod.method

        if (authmethodType === 'code_recovery') {
          emit('goTo', 'resetPassword')
        } else if (authmethodType === 'password') {
          returnAfterSuccess()
          requestPending.value = false
        }
      }
    }
  } else {
    emit('goTo', 'recoverVerification')
  }
  requestPending.value = false
}

function returnAfterSuccess() {
  authFlow.toggle(false)
}

function refresh() {
  emit('goTo', 'recoverVerification')
}
</script>

<style></style>
